import { render } from "./CategoryBarWithoutLines.vue?vue&type=template&id=1e81e824&lang=pug"
import script from "./CategoryBarWithoutLines.vue?vue&type=script&lang=js"
export * from "./CategoryBarWithoutLines.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__